import { StoreInfoValue } from '../../../../server';

type StoreInfoSplitByCategoryParams = {
    stores: StoreInfoValue[];
    sku?: string;
    favoriteStoreId?: string;
    highlightedStoreId?: string;
    isProductAvailableInWarehouse: boolean;
};

type StoreInfoSplitByCategoryReturnType = {
    availableStock: StoreInfoValue[];
    unavailableStock: StoreInfoValue[];
    favoriteStore: StoreInfoValue | undefined;
    highlightedStore: StoreInfoValue | undefined;
    availableLength: number;
    unavailableLength: number;
};

export const splitByStoreCategory = ({
    stores,
    sku,
    favoriteStoreId,
    highlightedStoreId,
    isProductAvailableInWarehouse,
}: StoreInfoSplitByCategoryParams): StoreInfoSplitByCategoryReturnType => {
    const isProductAvailableInStore = (storeInfo: StoreInfoValue) =>
        (storeInfo.products.find((product) => product.id === sku)?.isAvailable ?? false) &&
        storeInfo.deliveryOptions.clickAndCollect;

    return stores.reduce<StoreInfoSplitByCategoryReturnType>(
        (acc, currentStore) => {
            const isProductDTSAvailable = currentStore.deliveryOptions.deliveryToStore && isProductAvailableInWarehouse;

            if (isProductAvailableInStore(currentStore) || isProductDTSAvailable) {
                acc.availableLength += 1;
            } else {
                acc.unavailableLength += 1;
            }

            if (currentStore.id === highlightedStoreId) {
                return { ...acc, highlightedStore: currentStore };
            }

            if (currentStore.id === favoriteStoreId) {
                acc = { ...acc, favoriteStore: currentStore };
            } else if (isProductAvailableInStore(currentStore) || isProductDTSAvailable) {
                acc.availableStock.push(currentStore);
            } else {
                acc.unavailableStock.push(currentStore);
            }
            return acc;
        },
        {
            availableStock: [],
            unavailableStock: [],
            favoriteStore: undefined,
            highlightedStore: undefined,
            availableLength: 0,
            unavailableLength: 0,
        },
    );
};
